import thumbnail from './courseWrapper.png';
import Mediator from './Mediator';

export default {
    handle: 'courseWrapperCertificate',
    label: 'Course Wrapper with Supervision',
    thumbnail,
    mediatorComponent: Mediator,
};
